<template>
  <small class="m-t-5">
    {{ $t('changed') }}
    <span v-if="!hideInitial">
      {{ initial ? $t('from') + ' ' : '' }}
      {{ initial }}
    </span>
    &nbsp;
    <span class="c-indigo-500 f-500 pointer" @click="handleUndo">
      {{ $t('Undo') }}
    </span>
  </small>
</template>

<script>
export default {
  name: 'ContractFormFieldsUndo',

  props: {
    /**
     * Set field name
     */
    field: {
      type: String,
      required: true,
    },
    /**
     * Set other fields related to this undo
     * if set undo event will be trigger for them
     *
     */
    fields: {
      type: Array,
      default: () => [],
      validator: (v) => v.every((i) => typeof i === 'string'),
    },
    /**
     * Set field initial value.
     */
    initial: {
      type: String,
      default: '',
    },
    /**
     * Set if initial value should be hidden.
     */
    hideInitial: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleUndo() {
      this.$emit('undo', this.field)
      this.fields.forEach((f) => {
        this.$emit('undo', f)
      })
    },
  },
}
</script>
